import { ChangeEvent, Checkbox, DataDisplayEvent, LookupModelSearchEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutLMEUserCRM } from "./autogen/AutogenLayoutLMEUserCRM";

export class LMEUserCRM extends AutogenLayoutLMEUserCRM {
    textboxQuotePendActIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.typeOfFilter(event);
    }

    textboxQuoteCompActIdBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        this.typeOfFilter(event);
    }

    typeOfFilter(event: LookupModelSearchEvent) {
        event.filter.type_of = "C";
        event.filter.id = "!RECCALL";
    }

    checkboxQuotePendActCreateOnDataDisplay(event: DataDisplayEvent) {
        this.determineRequired(this.checkboxQuotePendActCreate, this.textboxQuotePendActId);
    }
    
    checkboxQuotePendActCreateOnChange(event: ChangeEvent) {
        this.determineRequired(this.checkboxQuotePendActCreate, this.textboxQuotePendActId);
    }

    checkboxQuoteCompActCreateOnDataDisplay(event: DataDisplayEvent) {
        this.determineRequired(this.checkboxQuoteCompActCreate, this.textboxQuoteCompActId);
    }

    checkboxQuoteCompActCreateOnChange(event: ChangeEvent) {
        this.determineRequired(this.checkboxQuoteCompActCreate, this.textboxQuoteCompActId);
    }

    determineRequired(checkbox: Checkbox, textbox: Textbox) {
        textbox.required = checkbox.checked;
    }
}